

import Error from "pages/Error";
import React, {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";

function AppNotLine() {
  // return "TEST";
  return (
    <Router>
      <Routes>
        <Route path="/error" element={<Error />} />
      </Routes>
    </Router>
  );
}

export default AppNotLine;
